"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const map_1 = __importDefault(require("lodash/map"));
/**
 * Formats the Quote API endpoint with addOnId, insuranceId, promoCode query string
 * To be used by Fleet Quote Api call
 * @param {string} endpoint
 * @param {FleetQuoteReqParamType} reqParams
 * @returns {string}
 */
function formatURLWithAddOnQueryParam(endpoint, reqParams) {
    const addOnIds = (0, get_1.default)(reqParams, 'addOnIds', null); // returns array if exists
    const insuranceIds = (0, get_1.default)(reqParams, 'insuranceIds', null); // returns array if exists
    const promoCode = (0, get_1.default)(reqParams, 'promoCode', ''); // returns string if exists
    const esc = encodeURIComponent;
    let addOnsQuery = '';
    if (addOnIds) {
        addOnsQuery = (0, map_1.default)(addOnIds, (addOnId) => {
            return `${esc('addOnIds')}=${esc(addOnId)}`;
        }).join('&');
    }
    let insuranceQuery = '';
    if (insuranceIds) {
        insuranceQuery = (0, map_1.default)(insuranceIds, (insuranceId) => {
            return `${esc('insuranceIds')}=${esc(insuranceId)}`;
        }).join('&');
    }
    let promoCodeQuery = '';
    if (promoCode) {
        promoCodeQuery = `promoCode=${promoCode}`;
    }
    return `${endpoint}?${addOnsQuery}&${insuranceQuery}&${promoCodeQuery}`;
}
exports.default = formatURLWithAddOnQueryParam;
